<ng-container *ngIf="formGroup" [formGroup]="formGroup">
	<div class="field-container">
		<mat-form-field
			[appearance]="appearance"
			[ngClass]="
				formGroup.controls.cprNumber.dirty
					? formGroup.controls.cprNumber.invalid
						? 'mat-form-field-invalid'
						: 'mat-form-field-success'
					: ''
			"
		>
			<mat-label>{{ "register.cprnumber" | translate }}</mat-label>
			<input
				matInput
				obgMatTooltip
				obgNoWhitespaceInput
				[obgMatTooltipDisabled]="inlineTips || tooltipDisabled"
				[matMenuTriggerFor]="tooltipCpr"
				type="tel"
				formControlName="cprNumber"
				[placeholder]="'register.cprnumber' | translate"
				test-id="cpr-number-field"
				data-test-id="cpr-number-field"
				[value]="fieldValue"
				[required]="required"
				(change)="fieldChange.emit('CPRNumber')"
			/>
			<mat-icon
				*ngIf="formGroup.controls.cprNumber.valid"
				class="ico-checkmark obg-m-registration-form-field-valid"
				matSuffix
			></mat-icon>
			<mat-hint *ngIf="inlineTips">
				{{ "login.type.e-id-select.cpr-number.hint" | translate }}
			</mat-hint>
		</mat-form-field>

		<obg-common-validation-renderer
			*ngIf="inlineTips"
			[input]="formGroup.controls.cprNumber"
			[translationPrefix]="translationPrefix"
		>
		</obg-common-validation-renderer>
	</div>
	<mat-menu #tooltipCpr="matMenu" class="obg-m-tooltip">
		<label>{{ "register.cpr.tooltip" | translate }}</label>
	</mat-menu>
</ng-container>
